import type { ReactNode, ReactElement } from 'react';

import { motion } from 'framer-motion';
// material
import { Box } from '@mui/material';
//
import { varWrapEnter } from './variants';

export interface MotionContainerProps {
  open?: boolean;
  children?: ReactNode;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function MotionContainer({
  open,
  children,
  ...other
}: MotionContainerProps) {
  return (
    <Box
      component={motion.div}
      initial={false}
      animate={open ? 'animate' : 'exit'}
      variants={varWrapEnter}
      {...other}
    >
      {children}
    </Box>
  );
}
